<template>
  <div class="project">
    <xk-side-menus ref="sideMenus"></xk-side-menus>
    <div class='topNav'>
      <span class="menuBut" @click="menuFn"><i class="iconfont icon-man"></i></span>
      <div class="yewu">
        <xk-tabs :acNum="0"></xk-tabs>
      </div>
    </div>
    <div class="projectContent">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  import XkTabs from '../module/tabs/src/tabs'
  import XkSideMenus from '../module/sideMenus/src/sideMenus'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      XkSideMenus,
      XkTabs
    },
    name: '',
    computed: {
      ...mapGetters({
        loginData: 'loginData'
      }),
      navFn: function () {
        let state = ''
        // // console.log(response)(this.$store.state.initdata.servesTypeNav)
        switch (this.$route.fullPath) {
          case '/daijia':
            state = 0
            break
          case '/zhuanche':
            state = 1
            break
          case '/paotui':
            state = 2
            break
          case '/zhuanxian':
            state = 3
            break
        }
        return state
      }
    },
    data () {
      return {}
    },
    methods: {
      menuFn: function () {
        let that = this
        console.log(1)
        that.$store.dispatch('checkLogin', (state) => {
          if (state && that.loginData && that.loginData.passenger) {
            window.clearTimeout(this.tId)
            this.tId = window.setTimeout(function () {
              that.$refs.sideMenus.sideMenusFn()
            }, 0)
          } else {
            // that.$store.dispatch('loginAction', {state: false})
            this.$router.push('/login')
          }
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .project {
    background-color: #f3f4f5;
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    .topNav {
      width: 100%;
      max-height: 100%;
      position: fixed;
      z-index: 250;
      left: 0;
      top: 0;
      box-sizing: border-box;
      padding: 0 1rem;
      background: #fff;
      line-height: 3.6rem;
      .menuBut {
        width: 1rem;
        float: left;
        i {
          font-size: 1.25rem;
        }
      }
      .yewu {
        float: left;
        margin-left: 1.5rem;
        width: calc(~'100% - 2.5rem');
      }
    }
    .projectContent {
      background-color: #f3f4f5;
      box-sizing: border-box;
      padding-top: 5rem;
      height: 100vh;
      /*overflow-y: scroll;*/
    }
  }

</style>



// WEBPACK FOOTER //
// project.vue?47457c30